import { Badge, Box, Dialog, DialogContent, Pagination, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { forwardRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import '../../../Styles/FormQuestionTable.css'
import { cn, compAnswerDateConvert, featValid } from 'src/lib/utils'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import EditPencilIcon from 'src/Common/Icon/EditPencilIcon'
import ContentCircle from 'src/Common/ui/contentCircle'
import { UPDATE_COMPLIANCE } from 'src/Entities/Features'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { IoMdCloseCircleOutline } from 'react-icons/io'
import { Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'

// eslint-disable-next-line react/display-name
export const UserFormsQuestionTable = forwardRef(({ editAccess, activeTab, setEditData, setDrawType, editState, setEditState, inputValidation, control, data, errors, onInputChangeTextArea, onInputChange, handleAddControls, handleDeleteControls, i }) => {
    // const formFileRef = useRef([])
    const location = useLocation()
    const viewCondition = () => {
        const path = location.pathname
        return path.includes('view-complaince')
    }
    const [ paginatedData, setPaginatedData ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(1)
    const { t } = useTranslation()
    const rowsPerPage = 5
    const totalPages = Math.ceil(data.length / rowsPerPage)
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }
    const defaultLayoutPluginInstance = defaultLayoutPlugin()

    const [ showPdf, setShowPdf ] = useState(false)
    const [ pdfBase64, setPdfBase64 ] = useState({})
    const handlePDFModelClose = () => {
        setShowPdf(false)
        setPdfBase64({})
    }
    const loadPdf = (data) => {
        setPdfBase64(data)
        setShowPdf(true)
    }
    useEffect(() => {
        if (data.length > 0) {
            if (viewCondition()) {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
            } else {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })))
            }
        }
    }, [ data, currentPage ])
    const handleEditClick = (data) => {
        setEditState({ right: true })
        setDrawType('form')
        setEditData(data)
    }
    const features = JSON.parse(localStorage.getItem('features'))
    const [ openDoc, setOpenDoc ] = useState(null)
    const handleDocClose = () => {
        setOpenDoc(null)
    }
    const handleOpenDoc = (event) => {
        setOpenDoc(event.target)
    }
    return (
        <>
            {<div style={{ display: activeTab === 2 ? 'block' : 'none', height: '100%' }}>
                <div className='h-[80%]'>
                    <TableContainer className={cn('forms-comp-table global-table')} >
                        <Table >
                            <TableHead >
                                <TableRow >
                                    <TableCell sx={{ border: 'none' }} colSpan={8}></TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px', color: 'hsl(var(--muted))' }} align='center' colSpan={2}><div className='text-muted'>Cost of Non Compliance</div></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align='center' sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, left: '0px' }}>#</TableCell>
                                    <TableCell className='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, left: '49px', minWidth: '300px' }}><p className={cn('comp-table-th px-2')}>{t('Form Name')}</p></TableCell>
                                    {/* <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, left: '301px' }}><p className={cn('comp-table-th w-[125px] px-2')}>{t('Documents')}</p></TableCell> */}
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, width: '100px', left: '301px' }}><p style={{ borderRight: '1.5px solid hsl(var(--table-bisector))' }} className='w-full flex items-center'><p className={cn('comp-table-th px-2')}>{'Hyperlink'}</p></p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('px-2')}>{t('Submit to')}</p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('comp-table-th px-2')}>Evidence</p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('comp-table-th px-2')}>Evidence Link</p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('comp-table-th px-2')}>By when</p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('comp-table-th px-2')}>Fine amount</p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('comp-table-th px-2')}>{t('Penalties and fines')}</p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('comp-table-th px-2')}>{t('Damage to reputation')}</p></TableCell>
                                    <TableCell className ='!px-0' align='center' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap' }}><p className={cn('comp-table-th px-2')}>Remarks</p></TableCell>
                                    {featValid(features, UPDATE_COMPLIANCE) && !editAccess && <TableCell className='!min-w-5' sx={{ fontWeight: 600, fontSize: '17px', whiteSpace: 'nowrap', position: 'sticky', top: 0, right: '0px' }}></TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    paginatedData?.map((item, j) => {
                                        return (
                                            <>
                                                <TableRow>
                                                    <TableCell className='col-sticky-td z-10' sx={{ width: '100px', left: 0 }}>
                                                        <div className='w-full flex justify-center'>
                                                            <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary'} content={item.sNo} />
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className='col-sticky-td z-10' sx={{ left: '49px' }}>
                                                        <p className='forms-comp-table-td flex justify-center'>
                                                            <div style={{ padding: '0 10px' }} className='!min-w-[200px]'>{item.documentName}</div>
                                                        </p>
                                                    </TableCell>
                                                    {/* <TableCell className='col-sticky-td' align='center' sx={{ left: '301px' }}>
                                                        <p className='forms-comp-table-td flex justify-center'>
                                                            <Badge badgeContent={item?.documents?.length} color="primary">
                                                                <img onClick={() => { formFileRef?.current[j]?.click() }} src='/Common/icon/SheetIcon.svg' />
                                                            </Badge>
                                                            <input
                                                                type="file"
                                                                ref={(el) => { formFileRef.current[j] = el }} // Proper way to assign ref
                                                                style={{ display: 'none' }} // Hide the default file input button
                                                            />
                                                        </p>
                                                    </TableCell> */}
                                                    <TableCell className='col-sticky-td z-10' sx={{ left: '301px ' }}>
                                                        <p style={{ borderRight: '1.5px solid hsl(var(--table-bisector))' }} className='h-[60px] flex items-center'>
                                                            <p className='forms-comp-table-td flex justify-center'>
                                                                <div style={{ padding: '0 10px' }} className='min-w-[200px]'>
                                                                    {item.hyperLink
                                                                        ? <a href={item.hyperLink} className='text-primary underline' target="_blank" rel="noreferrer" >
                                                                            {item.hyperLink }
                                                                        </a>
                                                                        : <div className='text-muted text-center'>NA</div>}
                                                                </div>

                                                            </p>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell sx={{}}>
                                                        <p className='flex justify-center'>
                                                            <div style={{ padding: '0 10px' }}>{item.submitTo || 'NA'}</div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell sx={{}}>
                                                        <Popover
                                                            open={Boolean(openDoc)}
                                                            anchorEl={openDoc}
                                                            onClose={handleDocClose}
                                                            anchorOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'right'
                                                            }}
                                                            transformOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'right'
                                                            }}
                                                        >
                                                            <Box className='flex flex-col gap-2' sx={{ p: 1 }}>
                                                                {item?.formResponses[0]?.attachment?.length > 0
                                                                    ? item?.formResponses[0]?.attachment?.map((mapData, mapIdx) => <Box onClick={() => loadPdf(mapData)} key={mapIdx} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', mr: 1 }}>
                                                                        <AiOutlineFilePdf style={{ color: 'red', marginRight: '8px' }} /><div className="text-primary" color="hsl(var(--primary))" style={{ textDecoration: 'underline', cursor: 'pointer' }}>{mapData?.fileName}</div></Box>)
                                                                    : <p className='font-bold text-primary'>-</p>}
                                                            </Box>
                                                        </Popover>
                                                        {item?.formResponses[0]?.attachment?.length > 0
                                                            ? <p className='relative z-0 cursor-pointer forms-comp-table-td flex justify-center'>

                                                                <div onClick={(e) => handleOpenDoc(e)} style={{ padding: '0 10px' }}>
                                                                    <Badge badgeContent={item?.formResponses[0]?.attachment?.length} color="primary">
                                                                        <img src='/Common/icon/SheetIcon.svg' />
                                                                    </Badge>
                                                                </div>

                                                            </p>
                                                            : <div className='w-full text-center'>-</div>}
                                                    </TableCell>
                                                    <TableCell sx={{}}>
                                                        <p className='forms-comp-table-td flex justify-center'>
                                                            <div style={{ padding: '0 10px' }}>{item?.formResponses[0]?.evidenceLink || '-'}</div>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell sx={{}}>
                                                        <p className='forms-comp-table-td flex justify-center'>
                                                            <div style={{ padding: '0 10px' }}>{compAnswerDateConvert(item?.formResponses[0]?.byWhen) || '-'}</div>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell sx={{}}>
                                                        <p className='forms-comp-table-td flex justify-center'>
                                                            <div style={{ padding: '0 10px' }}>{item.formResponses[0]?.fineAmount || '-'}</div>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{}}>
                                                        <p className='forms-comp-table-td flex justify-center'>
                                                            <div style={{ padding: '0 10px' }} className={cn('align-center', item.penaltiesandFine === 'All good' ? 'text-[hsl(var(--Low))] font-semibold' : 'text-[hsl(var(--danger))] font-semibold')}>{item.penaltiesandFine}</div>

                                                        </p></TableCell>
                                                    <TableCell align='center' sx={{}}>
                                                        <p className='forms-comp-table-td flex justify-center'>
                                                            <div style={{ padding: '0 10px' }} className={cn('align-center', item.damageToReputation === 'All good' ? 'text-[hsl(var(--Low))] font-semibold' : 'text-[hsl(var(--danger))] font-semibold')}>{item.damageToReputation}</div>

                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{}}>
                                                        <p className='forms-comp-table-td flex justify-center min-w-[100px]'>
                                                            <div style={{ padding: '0 10px' }} className='align-center'>{item.formResponses[0]?.remark || '-'}</div>

                                                        </p>
                                                    </TableCell>
                                                    {featValid(features, UPDATE_COMPLIANCE) && !editAccess && <TableCell sx={{ position: 'sticky', right: 0, zIndex: 2, width: '100px', background: 'hsl(var(--card))' }}>
                                                        <div className='flex w-[40px] justify-center cursor-pointer' onClick={() => handleEditClick(item)}>
                                                            <EditPencilIcon/>
                                                        </div>
                                                    </TableCell>}
                                                </TableRow>
                                            </>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                {data.length > 0 && <div className="border-t-2 border-t-primary-foreground flex items-center justify-between mt-2 p-4 h-[20%] w-full">
                    <Typography className="text-muted !text-h4">
                                Showing data {currentPage} to {rowsPerPage} of {totalPages} entries
                    </Typography>
                    <Pagination
                        sx={{ marginLeft: 'auto' }}
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded" />
                </div>}
            </div>}
            <Dialog
                open={showPdf}
                onClose={handlePDFModelClose}
                maxWidth="lg"
                fullWidth
            >
                <DialogContent style={{ height: '1050px' }}>
                    <div className='w-full flex flex-col mt-[-10px] mb-[10px] justify-end items-end'>
                        <IoMdCloseCircleOutline className='cursor-pointer' onClick={handlePDFModelClose} color='hsl(var(--muted))' size={25}/>
                    </div>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={`data:${pdfBase64?.contentType};base64,${pdfBase64?.file}`}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </DialogContent>
            </Dialog>
        </>
    )
})

UserFormsQuestionTable.propTypes = {
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    formFileRef: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onInputChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    i: PropTypes.number,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.func,
    setEditData: PropTypes.any,
    setDrawType: PropTypes.any,
    editState: PropTypes.any,
    setEditState: PropTypes.any
}

export default UserFormsQuestionTable
